export default __webpack_public_path__ + "images/assets/4644e2d2a47a3a093f79136882c5bb0e.svg";